var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.46218 12C5.18152 12 4.90842 11.9002 4.69319 11.7163L0.414229 8.0612C-0.0823784 7.63702 -0.140712 6.89101 0.283954 6.39485C0.708502 5.89869 1.45548 5.8403 1.95221 6.26472L5.27996 9.1073L11.8757 0.4655C12.2719 -0.0535895 13.0142 -0.153814 13.534 0.242122C14.0538 0.637821 14.1538 1.37946 13.7577 1.89855L6.40322 11.5346C6.20597 11.793 5.91099 11.959 5.58737 11.9934C5.5456 11.9978 5.50383 12 5.46218 12Z",
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightCheck);
export default __webpack_public_path__ + "static/media/light-check.a102c25b.svg";
export { ForwardRef as ReactComponent };